import React, { useState, useEffect } from "react";
import { ChevronRight, PlayCircle } from "lucide-react";
import Integration from "./Integration";
import './Hero.scss';
import analyticsDashboard from '../../../../assets/img/landing/analytics-dashboard.png';
import qtTerminal from '../../../../assets/img/landing/qt-terminal.png';
import qtDashboard from '../../../../assets/img/landing/qt-dashboard.png';
import { Link } from "react-router-dom";


const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const slides = [
    {
      url: analyticsDashboard,
      alt: "Trading Platform Dashboard"
    },
    {
      url: qtTerminal,
      alt: "QT Terminal Interface"
    },
    {
      url: qtDashboard,
      alt: "QT Dashboard View"
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 4000);

    return () => clearInterval(timer);
  }, [slides.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <section id="hero" className="hero">
      <div className="hero-container">
        <div className="hero-content">
          <h1 className="title">
            Supercharge your <span>Futures &amp; Options</span> Trading
          </h1>
          <p className="description">
            Transform your trading with our revolutionary platform for futures
            and options analysis, and execute them at a touch of a button. Don't
            settle for less, join us today.
          </p>
          
          <div className="buttons">
            <Link to="/pricing" className="primary">
              Start Free Trial <ChevronRight className="icon" />
            </Link>
            <a href="https://forms.gle/PE9GXiLLtxuJCqQV7" className="secondary">
              <PlayCircle className="icon" /> Register for Demo
            </a>
          </div>
        </div>

        <div className="preview">
          <div className="carousel">
            <div className="carousel-inner">
              {slides.map((slide, index) => (
                <div
                  key={index}
                  className={`carousel-slide ${index === currentSlide ? 'active' : ''}`}
                >
                  <img
                    src={slide.url}
                    alt={slide.alt}
                    loading={index === 0 ? "eager" : "lazy"}
                  />
                </div>
              ))}
            </div>
            
            <div className="carousel-indicators">
              {slides.map((_, index) => (
                <button
                  key={index}
                  className={`indicator ${index === currentSlide ? 'active' : ''}`}
                  onClick={() => goToSlide(index)}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
        
        <Integration />
      </div>
    </section>
  );
};

export default Hero;